export const criticalOperations = ['AMBEV PIRAI - CONLOG'];
